/* eslint-disable semi,semi-style */
import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import App from './app';
import useSign from '@/util/sign';
useSign();

render(<App />, document.getElementById('root'));
